import { BackgroundEditor, BackgroundEditorTypes, INamedColorsDefinition } from '@Common/Controls/BackgroundEditor';
import { Control } from '@Common/Controls/Controls';
import { Popup } from '@Common/Controls/Popup';
import ColorHelper from '@Common/Helpers/ColorHelper';
import pointerHelper from '@Common/Helpers/PointerHelper';
import StylesHelper from '@Common/Helpers/StylesHelper';

export interface IDropDownBackgroundEditorSetting {
    contentStyle?: string;
    maxContentHeight?: any;
    lineHeight?: any;
    types?: BackgroundEditorTypes[];
    css?: any;
    className?: string;
    width?: string;
    height?: string;
    isDisable?: boolean;
    isComponent?: boolean;
    titleStyle?: string;
    margins?: any;
    onShowContent?: IHandler;
    namedColors?: INamedColorsDefinition;
}

export interface IDropDownBackgroundEditor extends Control {
    getControl(): JQuery;

    getContent(): JQuery;

    disable();

    enable();

    getValue(): any;

    setValue(val: any);

    onChange(fn: IHandler);

    setState(enabled: boolean);
}

export const dropDownBackgroundEditor = function (param: IDropDownBackgroundEditorSetting): IDropDownBackgroundEditor {
    const content = $('<div class="drop-down-content popup-shadow"/>')
        .css({ top: param.lineHeight, position: 'absolute', maxHeight: param.maxContentHeight, minWidth: 200 })
        .addClass(param.contentStyle)
        .bind('removePopup', function () {
            removeContent();
        })
        .bind(pointerHelper.pointerDownEventName, function (e) {
            e.preventClearPopups();
        });
    param = $.extend(
        {
            css: null,
            className: '',
            width: '100%',
            height: 30,
            isDisable: false,
            isComponent: false,
            titleStyle: '',
            margins: {},
            onShowContent: $.noop,
            namedColors: null
        },
        param
    );
    param.margins = $.extend(
        {
            left: false,
            right: false,
            top: false,
            bottom: false
        },
        param.margins
    );

    let isDisable = param.isDisable;
    let isContentVisible = false;
    let onChange = _.noop;

    if (param.namedColors === true) {
        param.namedColors = ColorHelper.getCustomColors();
    }

    let _backgroundObject = null;
    const _backgroundStyle = null;

    const titleControl = $('<div class="name"/>');
    const root = $('<div class="drop-down drop-down-color-picker"/>')
        .append(titleControl)
        .append('<span class="dropdown-arrow"/>')
        .addClass(param.titleStyle)
        .css({ height: param.height + 'px', lineHeight: param.height + 'px', width: param.width })
        .find('.arrow')
        .end();
    if (param.isComponent) {
        root.addClass('component-drop-down');
    }
    root.applyMargins(param.margins);

    root.bind(pointerHelper.pointerDownEventName, function () {
        isContentVisible = content.is(':visible');
    }).click(
        function (e) {
            e.stopPropagation();

            if (!isDisable) {
                if (!isContentVisible) {
                    showContent();
                } else if (content.is(':visible')) {
                    removeContent();
                }
            }
        }.bind(this)
    );

    let popup;
    let cp;
    let cDiv;

    function showContent() {
        if (!cDiv) {
            cDiv = $('<div class="gradient-picker"></div>').appendTo(content);
            cp = new BackgroundEditor({ showButton: true, types: param.types, namedColors: param.namedColors });
            cp.onChange(function () {
                applySample(cp.getBackground());
            });
            cp.getControl().appendTo(cDiv);

            popup = new Popup({
                content: content,
                isHidden: true
            });

            popup.onClose(function () {
                root.removeClass('clicked');
                applySample(_backgroundObject);
            });

            cp.onOkClick(function () {
                _backgroundObject = cp.getBackground();
                popup.hide();
                onChange(_backgroundObject);
            });

            cp.onCancelClick(function () {
                popup.hide();
            });
        }

        root.addClass('clicked');

        if (_backgroundObject) {
            cp.setBackground(_backgroundObject);
        }

        popup.show(root.offset().left, root.offset().top + root.outerHeight());
        cp.adjust(400, 300);
        param.onShowContent();
    }

    function removeContent() {
        popup.hide();
        root.removeClass('clicked');
    }

    function applySample(background) {
        if (background) {
            let style = 'background:' + StylesHelper.getBackground(background, param.namedColors as any) + ';';
            style += 'background-size:' + StylesHelper.getBackgroundSize(background) + ';';
            titleControl.attr('style', style);
        } else {
            titleControl.attr('style', '');
        }
    }

    function setValue(background) {
        _backgroundObject = background;
        if (cp != null) {
            cp.setBackground(background);
        }
        applySample(_backgroundObject);
    }

    function getValue() {
        return _backgroundObject;
    }

    function disable() {
        root.addClass('disabled');
        isDisable = true;
    }

    function enable() {
        root.removeClass('disabled');
        isDisable = false;
    }

    return {
        getControl: function () {
            return root;
        },
        getContent: function () {
            return content;
        },
        disable: disable,
        enable: enable,
        getValue: getValue,
        setValue: setValue,
        onChange: function (fn) {
            if ($.isFunction(fn)) {
                onChange = fn;
            }
        },
        setState: function (enabled) {
            if (enabled) {
                enable();
            } else {
                disable();
            }
        }
    };
};
